module.exports = __webpack_public_path__ + "media/lib/close-d0690aa7.svg";